export default {
  download: {
    appName: 'Blueshark App',
    slogan: 'Smart travel in your hand',
    tips1: 'Minimum System Requirements: ',
    tips2: 'Android 8.0+; iOS 12+',
    weTips1:
      'The current environment does not support download and installation',
    weTips2:
      '1. Please select the upper right corner··· , and open with your browser',
    weTips3: '2. Open the browser to download and install',
    iosListTitle: 'Choose your country or region',
    androidListTitle: 'Choose the App version you need',
    ChineseVersion: 'Chinese mainland version',
    InoternationalVersion: 'International regional versions',
    asian: 'Asia-pacific region',
    european: 'European region'
  },
  support: {
    title: 'Support',
    productAndService: 'Product Support and Service',
    service: 'Maintenance and Service Policy',
    toService: 'Click to View Product After-Sales Maintenance Policy',
    view: 'View Now',
    product: 'User Manual',
    toProduct: 'Click to View and Download User Manual',
    chooseModel: 'Please Select the Model Based on Your Purchase',
    rModel: 'Blueshark R Series',
    hModel: 'Blueshark H Series'
  },
  R1config: {
    battery: 'Battery',
    capacity: 'Battery Capacity',
    NEDC: 'NEDC Range',
    powerType: 'Battery Cell Type',
    automotive: 'Lithium-Ion Battery Packs',
    charger: 'Charger',
    performance: 'Performance',
    motor: 'Motor',
    highSpeedMotor: 'High-speed brushless permanent magnet gear motor',
    topSpeed: 'Top Speed',
    ratedPower: 'Rated Power',
    peakPower: 'Peak Power',
    torque: 'Torque',
    gradability: 'Gradability',
    turbo: 'Turbo Mode',
    yes: 'Yes',
    no: 'No',
    mam: 'Move Assist Mode / MAM',
    smart: 'Smart',
    panel: 'Panel',
    IPSScreen: '10" Full-color High-definition IPS Screen',
    LCDScreen: '10" LCD Segment Screen',
    bluetooth: 'Bluetooth Navigation',
    frontalCamera: 'Frontal Camera',
    RearCamera: 'Rear Camera',
    optional: 'Optional',
    RAM: 'RAM',
    viewWhenTurn: 'Display rear view when turning',
    remainRange: 'Remain Range',
    bluesharkApp: 'Blueshark App',
    wireless: 'Wireless Connection',
    sensors: 'Number of Sensors',
    upgrade: 'OTA Upgrade',
    safe: 'Safe',
    smartKey: 'Bluetooth Smart Key',
    steeringLock: 'Electronic Steering Lock',
    seatLock: 'Electronic Seat Lock',
    triMode: 'Tri-mode Position',
    brake: 'Brake',
    CBS: 'Front & Rear Disc Brakes with CBS',
    ADAS: 'ADAS',
    remoteAlarm: 'Remote Alarm',
    sideStand: 'Side Stand Cutoff',
    virtualVroom: 'Virtual Vroom',
    light: 'Light',
    autoHeadlight: 'Auto Headlight',
    turnSignal: 'Turn Signal',
    HazardLight: 'Hazard Light',
    seatLight: 'Seat Illumination Light',
    carpetLight: 'Ambient Carpet Light',
    multimedia: 'Multimedia',
    speaker: 'Speaker',
    HighPowerSpeaker: 'High-power Speaker',
    basic: 'Basic',
    size: 'Size',
    LWH: '(Length * Width * Height)',
    wheelbase: 'Wheelbase',
    tire: 'Tire',
    front: 'Front',
    rear: 'Rear',
    groundClearance: 'Ground Clearance',
    weight: 'Weight(without battery)',
    colors: 'Colors',
    color:
      'Spindrift White / Deepsea Black / Blueshark Blue / Pine Green / Coconut Brown'
  },
  H1Product: {
    firstBG: {
      title: 'Blueshark H1',
      info: 'Smart Electric Light Scooter',
      slogan: ' ' // 无英文文案
    },
    colorName: {
      while: 'Soft Sand White',
      blue: 'Sea Salt Blue',
      green: 'Seaweed Green',
      pink: 'Coral Pink',
      black: 'Reef Black'
    },
    colorNameSlogan: {
      while: ' ', // 无英文文案
      blue: ' ', // 无英文文案
      green: ' ', // 无英文文案
      pink: ' ', // 无英文文案
      black: ' ' // 无英文文案
    },
    performance: {
      title: 'Rapid Pace',
      subTitle:
        'High-Speed Brushiess Permanent Magnet Gear Motor.<br/>The automobile-grade gearbox design and direct drive technology guarantee a high-efficient and stable power transmission.',
      maxPower: 'Peak Power',
      maxSpeed: 'Top Speed',
      torque: 'Wheel Torque',
      climbing: 'Gradability',
      swerve: 'Turning Radius'
    },
    gear: {
      title: 'Vectior Algorithm,<br/> Smooth Driving',
      subTitle: '3 regular driving modes and 2 driver assistance modes',
      model1: ' ', // 无英文文案
      model2: ' ', // 无英文文案
      model3: ' ' // 无英文文案
    },
    control: {
      title: 'Precise Handling',
      info: 'Easily Navigae Complex Environments'
    },
    battery: {
      title: 'Blueshark Battery Pack 2.0', // 英文调换位置
      info: 'Safe, Smart, Efficient, and Reliable', // 英文调换位置
      fastCharge: 'Fast Charging',
      largeCapacity: 'Ultra-high Capacity',
      endurance: 'Range',
      highlight1: 'Safer',
      highlight2: 'Reliable',
      highlightInfo1: ' ', // 无英文文案
      highlightInfo2: ' ', // 无英文文案
      highlightInfo3: ' ', // 无英文文案
      highlightInfo4: ' ', // 无英文文案
      highlightInfo5: ' ' // 无英文文案
    },
    cab: {
      title: 'Blueshark Smart<br/> Battery Swapping System',
      slogan: ' ', // 无英文文案
      noFeelChange: '无感换电',
      speedSwapping: '极速充电',
      info1: '3 秒换电',
      info2: '仅需两步，即换即走',
      info3: '2h 快速充电',
      info4: '单日可换电 150 次'
    },
    mam: {
      slogan: ' ' // 无英文文案
    },
    chip: {
      title: 'The Ultimate Brainpower',
      subTitle2: 'Power & System Domain Controllers',
      highDot1: 'MCU',
      highDot2: 'BMS',
      highDot3: 'Energy Distribution',
      content3: ' ', // 无英文文案
      content4: ' ', // 无英文文案
      content1:
        'The system domain controller connects to the Blueshark’s IoV system via a 4G communication module, while the other monitors and adjusts the driving status in real time.',
      content2:
        'Both of the domain controllers can work independently or connect as a unit through the CAN bus.'
    },
    os: {
      title: 'ArkRide OS 2.0',
      info1: 'Smart on-Scooter Operating System',
      info2: ' ', // 无英文文案
      info3: ' ', // 无英文文案
      content1: 'Starting Speed Enhanced',
      content2: 'Stability Increased',
      content3: 'Feedback Speed Enhanced'
    },
    screen: {
      title: 'Floating-Style Panel Display',
      info:
        'The Blueshark H1 rocks a full-color, high-brightness full-HD panel display that shows all the information from your driving status to music playback.<br />On top of it there is an ambient light sensor that detects your driving environment in real time.'
    },
    handlebar: {
      title: 'Fun at Your Fingertips',
      info: ' ', // 无英文文案
      content: ' ' // 无英文文案
    },
    key: {
      title: 'Automotive Bluetooth <br/> Smart Key System',
      info: ' ', // 无英文文案
      highDot1: 'Bluetooth',
      highDot2: 'Blueshark App'
    },
    app: {
      title1: 'Blueshark App',
      title2: ' ', // 无英文文案
      info: ' ', // 无英文文案
      highDot1: 'Vehicle Location',
      highDot2: 'Power Statistics',
      highDot3: 'Route Tracking',
      highDot4: 'Mileage Records'
    },
    bikeColor: {
      title: 'Blueshark H1 Colorways'
    },
    config: {
      title: 'Blueshark H1',
      c1: 'Rated Power',
      c2: 'Battery Capacity',
      c3: 'Top Speed',
      c4: 'Brake System',
      c5: 'Front and rear disc brakes',
      c6: 'Intelligent Operating System',
      c7: 'Rated maximum carrying capacity',
      c8: 'Body weight (including battery)',
      c9: 'Central Control Instrument',
      c10: '10" Full-color HD IPS Screen',
      c11: 'Wheelbase',
      c12: 'Seat Height',
      c13: 'Peak Power',
      c14: 'Range',
      c15: 'Intelligent Central Control System',
      c16: 'Power & System Domain Controllers',
      c17: 'Intelligent DAS',
      c18: 'Starting Method',
      c19: 'Bluetooth Smart Key',
      c21: 'Body Color',
      c22: 'Turning Radius',
      c23: 'Dimensions',
      c24: 'Ground Clearance'
    }
  },
  iosAsianCountryList: [
    { country: 'Australia', url: 'https://apps.apple.com/au/app/id1512077089' },
    { country: 'Cambodia', url: 'https://apps.apple.com/kh/app/id1512077089' },
    { country: 'China', url: 'https://apps.apple.com/cn/app/id1455603928' },
    { country: 'HongKong', url: 'https://apps.apple.com/hk/app/id1512077089' },
    { country: 'Indonesia', url: 'https://apps.apple.com/id/app/id1512077089' },
    { country: 'Korea', url: 'https://apps.apple.com/kr/app/id1512077089' },
    { country: 'Macao', url: 'https://apps.apple.com/mo/app/id1512077089' },
    { country: 'Malaysia', url: 'https://apps.apple.com/my/app/id1512077089' },
    {
      country: 'Philippines',
      url: 'https://apps.apple.com/ph/app/id1512077089'
    },
    { country: 'Singapore', url: 'https://apps.apple.com/sg/app/id1512077089' },
    { country: 'Taiwan', url: 'https://apps.apple.com/tw/app/id1512077089' },
    { country: 'Thailand', url: 'https://apps.apple.com/th/app/id1512077089' },
    { country: 'Vietnam', url: 'https://apps.apple.com/vn/app/id1512077089' }
  ],
  iosEuropeanCountryList: [
    { country: 'Albania', url: 'https://apps.apple.com/al/app/id1512077089' },
    { country: 'Austria', url: 'https://apps.apple.com/at/app/id1512077089' },
    { country: 'Belarus', url: 'https://apps.apple.com/by/app/id1512077089' },
    { country: 'Belgium', url: 'https://apps.apple.com/be/app/id1512077089' },
    {
      country: 'Bosnia & Herzegovina',
      url: 'https://apps.apple.com/ba/app/id1512077089'
    },
    { country: 'Bulgaria', url: 'https://apps.apple.com/bg/app/id1512077089' },
    { country: 'Croatia', url: 'https://apps.apple.com/hr/app/id1512077089' },
    {
      country: 'Czech Republic',
      url: 'https://apps.apple.com/cz/app/id1512077089'
    },
    { country: 'Denmark', url: 'https://apps.apple.com/dk/app/id1512077089' },
    { country: 'Estonia', url: 'https://apps.apple.com/ee/app/id1512077089' },
    { country: 'France', url: 'https://apps.apple.com/fr/app/id1512077089' },
    { country: 'Finland', url: 'https://apps.apple.com/fi/app/id1512077089' },
    { country: 'Germany', url: 'https://apps.apple.com/de/app/id1512077089' },
    { country: 'Greece', url: 'https://apps.apple.com/gr/app/id1512077089' },
    { country: 'Hungary', url: 'https://apps.apple.com/hu/app/id1512077089' },
    { country: 'Iceland', url: 'https://apps.apple.com/is/app/id1512077089' },
    { country: 'Italy', url: 'https://apps.apple.com/it/app/id1512077089' },
    { country: 'Ireland', url: 'https://apps.apple.com/ie/app/id1512077089' },
    { country: 'Latvia', url: 'https://apps.apple.com/lv/app/id1512077089' },
    { country: 'Lithuania', url: 'https://apps.apple.com/lt/app/id1512077089' },
    {
      country: 'Luxembourg',
      url: 'https://apps.apple.com/lu/app/id1512077089'
    },
    { country: 'Malta', url: 'https://apps.apple.com/mt/app/id1512077089' },
    { country: 'Moldova', url: 'https://apps.apple.com/md/app/id1512077089' },
    {
      country: 'Montenegro',
      url: 'https://apps.apple.com/me/app/id1512077089'
    },
    {
      country: 'Netherlands',
      url: 'https://apps.apple.com/nl/app/id1512077089'
    },
    { country: 'Norway', url: 'https://apps.apple.com/no/app/id1512077089' },
    { country: 'Poland', url: 'https://apps.apple.com/pl/app/id1512077089' },
    { country: 'Portugal', url: 'https://apps.apple.com/pt/app/id1512077089' },
    { country: 'Romania', url: 'https://apps.apple.com/ro/app/id1512077089' },
    { country: 'Russia', url: 'https://apps.apple.com/ru/app/id1512077089' },
    { country: 'Serbia', url: 'https://apps.apple.com/rs/app/id1512077089' },
    { country: 'Slovakia', url: 'https://apps.apple.com/sk/app/id1512077089' },
    { country: 'Slovenia', url: 'https://apps.apple.com/si/app/id1512077089' },
    { country: 'Spain', url: 'https://apps.apple.com/es/app/id1512077089' },
    { country: 'Sweden', url: 'https://apps.apple.com/se/app/id1512077089' },
    {
      country: 'Switzerland',
      url: 'https://apps.apple.com/ch/app/id1512077089'
    },
    { country: 'Ukraine', url: 'https://apps.apple.com/ua/app/id1512077089' },
    {
      country: 'United Kingdom',
      url: 'https://apps.apple.com/gb/app/id1512077089'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/i18n/en.js